import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import "./InternalNavbar.css";

const InternalNavbar = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'skills', 'education', 'experience', 'projects', 'achievements', 'certifications', 'contact'];
      const scrollPosition = window.scrollY + 200;

      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="internal-navbar">
      <div className="internal-navbar-container">
        <div className="internal-nav-links">
          <Link
            to="home"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'home' ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link
            to="skills"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'skills' ? 'active' : ''}`}
          >
            Skills
          </Link>
          <Link
            to="education"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'education' ? 'active' : ''}`}
          >
            Education
          </Link>
          <Link
            to="experience"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'experience' ? 'active' : ''}`}
          >
            Experience
          </Link>
          <Link
            to="projects"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'projects' ? 'active' : ''}`}
          >
            Projects
          </Link>
          <Link
            to="achievements"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'achievements' ? 'active' : ''}`}
          >
            Achievements
          </Link>
          <Link
            to="certifications"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'certifications' ? 'active' : ''}`}
          >
            Certificates
          </Link>
          <Link
            to="contact"
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
            className={`internal-nav-link ${activeSection === 'contact' ? 'active' : ''}`}
          >
            Contact Me
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default InternalNavbar;
